
import React from 'react';
import  Users  from './Components/Users';

function App() {
  return (
    <Users />
  );
}

export default App;
